export default __webpack_public_path__ + "static/NeedsSection_us-8a2dd729bf2b045c184fbf5a867fdd60.png";